import { gql } from '@apollo/client';

const DELETE_TRAINEESHIP = gql`
  mutation deleteTraineeship($traineeshipID: String!, $pathName: String!) {
    deleteTraineeship(traineeshipID: $traineeshipID, pathName: $pathName)
  }
`;

export default DELETE_TRAINEESHIP;